import { render, staticRenderFns } from "./FuncCorteSuprema.vue?vue&type=template&id=295dd9b1&"
import script from "./FuncCorteSuprema.vue?vue&type=script&lang=js&"
export * from "./FuncCorteSuprema.vue?vue&type=script&lang=js&"
import style0 from "vue-slim-tabs/themes/default.css?vue&type=style&index=0&lang=css&"
import style1 from "./FuncCorteSuprema.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports